import { render, staticRenderFns } from "./genelparametreler.vue?vue&type=template&id=03bdd041&"
import script from "./genelparametreler.vue?vue&type=script&lang=js&"
export * from "./genelparametreler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports